export default __webpack_public_path__ + "static/media/pdf_icon.6c9fedeb.png";